import {
  DiscardIssueRequestDto,
  IssueResponseDto,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type Params = {
  code: string;
  onSuccess?: () => void;
};

export function useDiscardIssue({ code, onSuccess }: Params) {
  const api = useApi();

  const queryClient = useQueryClient();

  return useMutation<
    IssueResponseDto,
    ExtendedAxiosError,
    DiscardIssueRequestDto
  >({
    mutationKey: ['issues', code, 'discard'],
    mutationFn: (r) => api.issuesApi.discardIssue(code, r).then((r) => r.data),
    onSuccess: async (response) => {
      onSuccess?.();
      queryClient.setQueryData<IssueResponseDto>(['issues', code], response);
    },
  });
}
